export default __webpack_public_path__ + "locales/uk-UA/SmartBanner.json?hash=1a5268aa7d8eaab03970aed68f353503";